import React, { useEffect, useRef } from 'react';

const ProgressBorder = ({ progress = 0, borderRadius = 18, strokeWidth = 2 }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;

    // Set canvas size
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    ctx.scale(dpr, dpr);

    // Clear canvas
    ctx.clearRect(0, 0, rect.width, rect.height);

    // Calculate dimensions
    const width = rect.width;
    const height = rect.height;
    const halfStroke = strokeWidth / 2;

    // Calculate path length for progress
    const perimeter = 2 * (width + height - 4 * borderRadius) + 2 * Math.PI * borderRadius;
    const progressLength = (progress / 100) * perimeter;

    // Draw rounded rectangle path
    ctx.beginPath();
    ctx.moveTo(borderRadius + halfStroke, halfStroke);
    
    // Top line
    ctx.lineTo(width - borderRadius - halfStroke, halfStroke);
    // Top-right corner
    ctx.arcTo(width - halfStroke, halfStroke, width - halfStroke, borderRadius + halfStroke, borderRadius);
    // Right line
    ctx.lineTo(width - halfStroke, height - borderRadius - halfStroke);
    // Bottom-right corner
    ctx.arcTo(width - halfStroke, height - halfStroke, width - borderRadius - halfStroke, height - halfStroke, borderRadius);
    // Bottom line
    ctx.lineTo(borderRadius + halfStroke, height - halfStroke);
    // Bottom-left corner
    ctx.arcTo(halfStroke, height - halfStroke, halfStroke, height - borderRadius - halfStroke, borderRadius);
    // Left line
    ctx.lineTo(halfStroke, borderRadius + halfStroke);
    // Top-left corner
    ctx.arcTo(halfStroke, halfStroke, borderRadius + halfStroke, halfStroke, borderRadius);

    // Gray border first
    ctx.strokeStyle = '#4b4b4b';
    ctx.lineWidth = strokeWidth;
    ctx.stroke();

    // Green progress border
    if (progress > 0) {
      ctx.strokeStyle = '#D1FF03';
      ctx.lineWidth = strokeWidth;
      ctx.setLineDash([progressLength, perimeter]);
      ctx.lineDashOffset = 0;
      ctx.stroke();
    }

  }, [progress, borderRadius, strokeWidth]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 2
      }}
    />
  );
};

export default ProgressBorder;